




















































import { MessageDialog } from '../../utils/MessageDialog';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Session } from '../../utils/Session';
import { DailyReportServiceExt } from '../../biz/DailyReportServiceExt';
import { ReportDTO } from '../../../src_server/entity/dto/ReportDTO';
import BasicStrengthPanel from './BasicStrengthPanel.vue';
import { dayjs, DT_FORMAT_JA, DT_FORMAT_JA_WO_Y } from '../../../src_server/common/momentExtends';
import { subjectsOptions } from '../../../src_server/entity/master/subjectsData';
import SimpleSelect from '../../components/inputs/SimpleSelect.vue';
import { DaDailyReportService } from '../../biz/remote/DaDailyReportService';
import TermTargetPanel from './TermTargetPanel.vue';
import { routeHelperOpenNewTab } from '../../utils/routeHelper';

@Component({
  components: {
    BasicStrengthPanel,
    SimpleSelect,
    TermTargetPanel,
  },
  filters: {
    dateFormat: (dt: Date) => {
      return dayjs(dt).format(DT_FORMAT_JA);
    },
    dateFormatWoY: (dt: Date) => {
      return dayjs(dt).format(DT_FORMAT_JA_WO_Y);
    },
  },
})
export default class DaReportDocPage extends Vue {
  private dto: ReportDTO = new ReportDTO();
  private class_id = 0;

  get subjects() {
    return subjectsOptions;
  }

  async loadReport() {
    const class_id_param = this.$route.query.class_id as string;
    if (!class_id_param) {
      MessageDialog.systemError('レッスンID', '日報表示時', class_id_param).then();
      return;
    }
    // 引数は文字列になっているので数値化
    this.class_id = parseInt(class_id_param);

    // 日報データを取得
    const biz = new DailyReportServiceExt();
    const resonse = await biz.getReportForInput(this.class_id, Session.getSessionUserId());
    if (resonse.hasError) {
      await MessageDialog.systemError('日報', '日報表示時', resonse.data);
      return;
    }
    this.dto = resonse.data;

    if (!this.dto.report.auther_name) {
      this.dto.report.auther_name = Session.getSessionNickName();
    }

    // // 編集モードだったら、一時保存されているデータを取り出す
    // const repBiz = new DailyReportServiceExt();
    // const sessionDTO = repBiz.laoadTemp(this.class_id);
    // if (sessionDTO) {
    //   this.dto = sessionDTO;
    // }
  }

  async mounted() {
    await this.loadReport();
  }

  /**
   * 記入中の内容を保存
   */
  writeingSave() {
    const biz = new DailyReportServiceExt();
    biz.saveTemp(this.class_id, this.dto);
  }

  /**
   * 基礎力レベルのコールバック
   */
  changeStrength(value: boolean, index: number) {
    this.dto.strength[index].is_done = value;
  }

  editEpisode(value: string, index: number) {
    this.dto.strength[index].episode = value;
  }

  /**
   * 日報の最初の送信
   */
  async send() {
    const isOk = await MessageDialog.confirm('日報(内部管理資料)を保存します。よろしいですか。');
    if (isOk) {
      const biz = new DaDailyReportService();
      await biz.save(this.dto, Session.getSessionBuildingId());
      await MessageDialog.alert(`日報(内部管理資料)を保存しました。`);
    }
  }

  print() {
    routeHelperOpenNewTab(this, 'ReportPrintPage', { class_id: this.class_id });
  }
}
